import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
import { Toaster } from './components/ui/Toaster';
import { ConfirmProvider } from './components/ui/ConfirmDialog';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root no encontrado');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
      <Toaster />
    </ErrorBoundary>
  </StrictMode>,
);
